import { isInRoles } from "./authorize.directive";
import Roles from "./roles";
import i18n from '@/i18n/i18n';

export function textareaAutoGrow(evt) {
    let min = 35;
    if (evt.target.rows) {
      min = 21 * evt.target.rows
    }
    if (evt.target.scrollHeight > min) {
      min = evt.target.scrollHeight
    }
    if (!evt.target.style.maxHeight || evt.target.style.maxHeight < min) {
      evt.target.style.overflow = 'hidden';
    }
    evt.target.style.height = (min) + "px";
  }

export function generateUUID() {
    // Generate an array of 16 random bytes
    const array = new Uint8Array(16);
    window.crypto.getRandomValues(array);

    // Set the version to 4 (UUID version 4)
    array[6] = (array[6] & 0x0f) | 0x40;
    // Set the variant to 2 (UUID variant specified in RFC 4122)
    array[8] = (array[8] & 0x3f) | 0x80;

    // Convert the byte array to a UUID string
    const uuid = Array.from(array).map((byte, index) => {
        // Add hyphens at the appropriate positions
        if (index === 4 || index === 6 || index === 8 || index === 10) {
            return '-' + byte.toString(16).padStart(2, '0');
        }
        return byte.toString(16).padStart(2, '0');
    }).join('');

    return uuid;
}

export function printElem(divContent, title = 'print')
{
    // Create a new window
    const screenWidth = window.screen.width;
      const screenHeight = window.screen.height;
      const printWindow = window.open('', '', `width=${screenWidth},height=${screenHeight},fullscreen=yes`);


    // Get the stylesheets
    let styles = '<style>';
      for (let i = 0; i < document.styleSheets.length; i++) {
        try {
          const rules = document.styleSheets[i].cssRules || document.styleSheets[i].rules;
          for (let j = 0; j < rules.length; j++) {
            styles += rules[j].cssText;
          }
        } catch (e) {
          console.warn("Could not load stylesheet: " + document.styleSheets[i].href, e);
        }
      }
      styles += '</style>';

    // Write the content to the new window
    printWindow.document.write('<html><head><title>'+title+'</title>');
    printWindow.document.write(styles);
    printWindow.document.write('</head><body style="background-color: #fff;">');
    printWindow.document.write('<div style="background-color: #fff;">' + divContent.innerHTML + '</div>');
    printWindow.document.write('</body></html>');

    // Close the document to finish writing
    printWindow.document.close();

    // Wait for the content to load and then print
    printWindow.onload = function() {
      printWindow.print();
      printWindow.close();
    };
}

export function resolveLoginSuccess(router, route) {
  if (isInRoles(Roles.AcceptTerms)) {
    router.push({
      name: 'terms-and-conditions'
    });
  } else if (isInRoles(Roles.FillClientData)) {
    router.push({
      name: 'informacoes-adicionais-dados-basicos'
    });
  } else if (isInRoles(Roles.ResponderPesquisa)) {
    router.push({
      name: 'responder-pesquisa'
    });
  } else if (route && route.query && route.query.redirectTo) {
    router.push({
      path: route.query.redirectTo
    });
  } else {
    router.push({
      path: '/'
    });
  }
} 


export function transformTextareaContentToHtml(content) {
  return substituirURLsPorLinks(content?.replace(/\n/g, ' <br /> ') ?? '')
}

// Formata um valor numérico como moeda BRL respeitando o locale ativo.
// `fallback` é retornado quando o valor é nulo, vazio ou não numérico.
export function formatCurrencyBRL(value, fallback) {
  const formatter = new Intl.NumberFormat(i18n.global.locale.value, {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
  });
  const resolvedFallback = fallback ?? formatter.format(0);
  if (value == null || value === '') return resolvedFallback;
  const num = Number(value);
  if (Number.isNaN(num)) return resolvedFallback;
  return formatter.format(num);
}

export function getIniciais(nome) {
  const fallbackName = i18n.global.t('utils.common.unidentified');
  var split = (nome ?? fallbackName).split(' ');
  var iniciais = (nome ?? fallbackName)[0]
  if (split.length > 1) {
    iniciais += split[split.length - 1][0]
  }
  return iniciais.toUpperCase()
}

export function substituirURLsPorLinks(texto) {
  const regexURL = /https?:\/\/[^\s]+/g;
  
  const textoComLinks = texto.replace(regexURL, (url) => {
      return `<a href="${url}" target="_blank">${url}</a>`;
  });

  return textoComLinks;
}


export function getLinkWhatsapp() {
  const texto = i18n.global.t('utils.whatsapp.supportMessage', {
    name: localStorage.getItem('mention.username') ?? '',
    company: localStorage.getItem('mention.cliente') ?? '',
  });
  return `https://api.whatsapp.com/send/?phone=551152170177&text=${encodeURI(texto)}&type=phone_number&app_absent=0`;
}

// Número do comercial/financeiro, usado no acesso suspenso por cobrança não concluída.
// Diferente do getLinkWhatsapp: quem chega aqui pode estar deslogado, então a mensagem não
// depende de nome ou empresa guardados na sessão.
export function getLinkWhatsappFinanceiro() {
  const empresa = localStorage.getItem('mention.cliente');
  const texto = empresa
    ? i18n.global.t('utils.whatsapp.billingMessageWithCompany', { company: empresa })
    : i18n.global.t('utils.whatsapp.billingMessage');
  return `https://api.whatsapp.com/send/?phone=5511919979519&text=${encodeURI(texto)}&type=phone_number&app_absent=0`;
}



function urlSafeToBase64(str) {
  return str.replace(/-/g, '+').replace(/_/g, '/');
}
function addPadding(str) {
  const padding = '='.repeat((4 - (str.length % 4)) % 4);
  return str + padding;
}
function decodeBase64Unicode(str) {
  return decodeURIComponent(
    Array.from(atob(str), c =>
      '%' + c.charCodeAt(0).toString(16).padStart(2, '0')
    ).join('')
  );
}
export function atobV2(strValue) {
  var base64String = urlSafeToBase64(strValue);
  base64String = addPadding(base64String);
  return decodeBase64Unicode(base64String);
}